/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

const GetDeliverableFormatData = (asset) => {
    // See Jeff's comment on BRAIN-3016 for biz logic
    // MXF: when hardac = false
    // MP4: when hardac = true && sourceContentType = proxy
    // MXF/MP4 when hardac = true and sourceContentType = ProRes

    let data = {
        className: 'label label-danger',
        text: 'common.video-delivery-format.na',
        tooltip: 'common.video-delivery-format.na.tooltip',
        videoExtensions: [],
    };

    if (asset.get('hardac') === false) {
        data.className = 'label label-gray',
        data.text = 'common.video-delivery-format.mxf';
        data.tooltip = 'common.video-delivery-format.mxf.tooltip';
        data.videoExtensions.push('PRO_RES', 'XDCAM');
    } else {
        switch (asset.get('sourceContentType')) {
        case 'Proxy':
            data.className = 'label label-gray',
            data.text = 'common.video-delivery-format.mp4';
            data.tooltip = 'common.video-delivery-format.mp4.tooltip';
            data.videoExtensions.push('H.264');
            break;

        case 'ProRes':
            data.className = 'label label-gray',
            data.text = 'common.video-delivery-format.mxf-mp4';
            data.tooltip = 'common.video-delivery-format.mxf-mp4.tooltip';
            data.videoExtensions.push('H.264', 'PRO_RES', 'XDCAM');
            break;

        default:
            data.className = 'label label-danger';
            data.text = 'common.video-delivery-format.na';
            data.tooltip = 'common.video-delivery-format.na.tooltip';
            data.videoExtensions.push('N/A');
            break;
        }

    }

    return data;
};

export {
    GetDeliverableFormatData
};
